/**
 * Services data for the Services page
 * Centralized location for easy maintenance and updates
 */

export const services = [
  {
    id: 'germany',
    country: 'Germany',
    flag: '🇩🇪',
    color: 'from-gray-50 to-gray-100',
    borderColor: 'border-gray-300',
    highlight: 'Tuition-free public universities with world-class education',
    programs: [
      {
        id: 'bach',
        title: "Bachelor's Degree",
        description: 'Tuition-free public universities with world-class education',
        features: ['Public Universities', 'Uni-Assist Application', 'APS Certificate', 'Visa Support']
      },
      {
        id: 'masters',
        title: "Master's Degree",
        description: 'Advanced degrees with research opportunities',
        features: ['Public Universities', 'Course Selection', 'APS Certificate', 'Visa Support']
      },
      {
        id: 'phd',
        title: 'PhD Programs',
        description: 'Research-focused doctoral programs',
        features: ['Supervisor Matching', 'Research Proposal', 'Funding Support', 'Visa Support']
      },
      {
        id: 'chancenkarte',
        title: 'Chancenkarte',
        description: 'Job seeker visa for skilled professionals',
        features: ['Points Assessment', 'Documentation', 'Job Search Support', 'Visa Processing']
      },
      {
        id: 'aupair',
        title: 'Au Pair',
        description: 'Cultural exchange and language learning',
        features: ['Host Family Matching', 'Contract Support', 'Visa Processing', 'Pre-departure']
      },
      {
        id: 'language',
        title: 'Language Visa',
        description: 'German language learning programs',
        features: ['Language School', 'Course Selection', 'Visa Support', 'Accommodation']
      },
      {
        id: 'ausbildung',
        title: 'Ausbildung',
        description: 'Vocational training programs',
        features: ['Company Matching', 'Application Support', 'Visa Processing', 'Integration']
      }
    ]
  },
  {
    id: 'canada',
    country: 'Canada',
    flag: '🇨🇦',
    color: 'from-red-50 to-red-100',
    borderColor: 'border-red-300',
    highlight: 'Study loans up to 75% tuition, repayable over 4–7 years at 11% APR',
    programs: [
      {
        id: 'certificate',
        title: 'Certificate Programs',
        description: 'Short-term career-focused programs',
        features: ['College Applications', 'Study Permit', 'Loan Assistance', 'Visa Support']
      },
      {
        id: 'diploma',
        title: 'Diploma Programs',
        description: '2-3 year technical and professional programs',
        features: ['College Applications', 'Study Permit', 'Loan Assistance', 'Visa Support']
      },
      {
        id: 'bachelors',
        title: "Bachelor's Degree",
        description: '4-year undergraduate programs',
        features: ['University Applications', 'Study Permit', 'Loan Assistance', 'Visa Support']
      },
      {
        id: 'pg-diploma',
        title: 'Post-Graduate Diploma',
        description: 'Career advancement programs',
        features: ['University Applications', 'Study Permit', 'Loan Assistance', 'Visa Support']
      },
      {
        id: 'masters-ca',
        title: "Master's Degree",
        description: 'Advanced graduate programs',
        features: ['University Applications', 'Study Permit', 'Loan Assistance', 'Visa Support']
      },
      {
        id: 'phd-ca',
        title: 'PhD Programs',
        description: 'Research doctoral programs',
        features: ['Supervisor Matching', 'Research Proposal', 'Funding Support', 'Study Permit']
      }
    ]
  },
  {
    id: 'australia',
    country: 'Australia',
    flag: '🇦🇺',
    color: 'from-yellow-50 to-yellow-100',
    borderColor: 'border-yellow-300',
    programs: [
      {
        id: 'bach-au',
        title: "Bachelor's Degree",
        description: 'Undergraduate programs at top universities',
        features: ['University Applications', 'Student Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'masters-au',
        title: "Master's Degree",
        description: 'Postgraduate programs',
        features: ['University Applications', 'Student Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'topup',
        title: 'Top-up Degree',
        description: 'Complete your degree in Australia',
        features: ['Credit Transfer', 'University Applications', 'Student Visa', 'Support']
      }
    ]
  },
  {
    id: 'uk',
    country: 'United Kingdom',
    flag: '🇬🇧',
    color: 'from-blue-50 to-blue-100',
    borderColor: 'border-blue-300',
    programs: [
      {
        id: 'bach-uk',
        title: "Bachelor's Degree",
        description: 'Prestigious UK university programs',
        features: ['UCAS Applications', 'Tier 4 Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'masters-uk',
        title: "Master's Degree",
        description: 'One-year intensive programs',
        features: ['University Applications', 'Tier 4 Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'topup-uk',
        title: 'Top-up Degree',
        description: 'Complete your degree in the UK',
        features: ['Credit Transfer', 'University Applications', 'Tier 4 Visa', 'Support']
      }
    ]
  },
  {
    id: 'newzealand',
    country: 'New Zealand',
    flag: '🇳🇿',
    color: 'from-green-50 to-green-100',
    borderColor: 'border-green-300',
    programs: [
      {
        id: 'bach-nz',
        title: "Bachelor's Degree",
        description: 'Quality education in a stunning environment',
        features: ['University Applications', 'Student Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'masters-nz',
        title: "Master's Degree",
        description: 'Postgraduate studies',
        features: ['University Applications', 'Student Visa', 'Course Selection', 'Pre-departure']
      },
      {
        id: 'work-visa',
        title: 'Work Visa',
        description: 'Skilled migration pathways',
        features: ['Points Assessment', 'Job Matching', 'Visa Processing', 'Settlement']
      }
    ]
  }
];

export const additionalServices = [
  {
    id: 'documents',
    icon: '📝',
    title: 'Document Preparation',
    description: 'Expert assistance with SOP, CV, recommendation letters, and all application documents'
  },
  {
    id: 'financial',
    icon: '🏦',
    title: 'Financial Support',
    description: 'Blocked account setup, financial planning, and loan assistance for eligible programs'
  },
  {
    id: 'departure',
    icon: '✈️',
    title: 'Pre-Departure Support',
    description: 'Travel arrangements, insurance, accommodation assistance, and orientation'
  },
  {
    id: 'visa-insurance',
    icon: '🛡️',
    title: 'Visa & Insurance',
    description: 'Complete visa documentation, health insurance setup, and interview preparation'
  },
  {
    id: 'university',
    icon: '🎓',
    title: 'University Applications',
    description: 'Strategic university selection, application management, and admission follow-up'
  },
  {
    id: 'family',
    icon: '👨‍👩‍👧',
    title: 'Family Visa Support',
    description: 'Spouse and dependent visa applications with 25% discount for PRO members'
  }
];

/**
 * Service features highlights
 */
export const serviceHighlights = [
  {
    title: 'End-to-End Support',
    value: '100%',
    description: 'From application to arrival',
    icon: '🎯'
  },
  {
    title: 'Success Rate',
    value: '99%',
    description: 'For qualified applicants',
    icon: '✅'
  },
  {
    title: 'Countries',
    value: '5',
    description: 'Germany, Canada, Australia, UK, NZ',
    icon: '🌍'
  },
  {
    title: 'Experience',
    value: '10+',
    description: 'Years in education consulting',
    icon: '⭐'
  }
];
